import React from "react";
import { Link } from "react-router-dom";
import { Lock, Check, Calendar, BookMarked } from "lucide-react";

const cycleStyle = {
  encuentro: { label: "Ciclo del Encuentro", bar: "bg-accent", chip: "bg-accent/10 text-accent" },
  sacramental: { label: "Ciclo Sacramental", bar: "bg-primary", chip: "bg-primary/10 text-primary" },
  franciscano: { label: "Ciclo Franciscano", bar: "bg-secondary", chip: "bg-secondary/15 text-secondary" },
};

export default function TimelineItem({ topic, index, completed, unlocked, level }) {
  const style = cycleStyle[topic.cycle] || cycleStyle.encuentro;
  const isLeft = index % 2 === 0;

  return (
    <div
      className="relative grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center mb-10"
      data-testid={`timeline-item-${topic.id}`}
    >
      {/* Center number */}
      <div className="hidden md:block absolute left-1/2 top-8 -translate-x-1/2 z-10">
        <div className={`w-14 h-14 rounded-full flex items-center justify-center font-display text-xl border-4 border-background ${
          completed ? "bg-accent text-white" : unlocked ? style.bar + " text-white" : "bg-muted text-foreground/40"
        }`}>
          {completed ? <Check className="w-5 h-5" /> : !unlocked ? <Lock className="w-4 h-4" /> : topic.order}
        </div>
      </div>

      {/* Card on alternating sides */}
      <div className={`${isLeft ? "md:pr-16" : "md:col-start-2 md:pl-16"}`}>
        <Link
          to={`/tema/${topic.id}`}
          className={`block group rounded-2xl p-6 bg-card border border-border shadow-sm hover:-translate-y-1 hover:shadow-lg transition-all duration-300 ${!unlocked ? "locked" : ""}`}
          data-testid={`topic-card-${topic.id}`}
        >
          <div className="flex items-center gap-2 mb-3">
            <span className={`px-3 py-1 rounded-full text-xs font-semibold tracking-wide ${style.chip}`}>
              {style.label}
            </span>
            <span className="flex items-center gap-1 text-xs text-foreground/60">
              <Calendar className="w-3 h-3" /> {topic.date_label}
            </span>
          </div>
          <h3 className="font-display text-2xl text-foreground group-hover:text-primary transition-colors">
            {topic.title}
          </h3>
          <p className="mt-2 text-sm text-foreground/70 line-clamp-2">{topic.focus}</p>
          <div className="mt-4 flex items-center gap-2 text-xs text-secondary font-semibold">
            <BookMarked className="w-3 h-3" /> {topic.bible_ref}
          </div>
        </Link>
      </div>

      {/* Empty placeholder for alignment */}
      {isLeft ? <div className="hidden md:block" /> : <div className="hidden md:block md:col-start-1 md:row-start-1" />}
    </div>
  );
}
